import CancelIcon from "@mui/icons-material/Cancel";

import Dropdown from "@musicfy/components/Dropdown";

export enum License {
  ROYALTY_FREE = "Royalty Free",
  COPYRIGHTED = "Community",
  PARODY = "Parody",
}

interface ILicenseFilterProps {
  licenseFilter: License | null;
  setLicenseFilter: React.Dispatch<React.SetStateAction<License | null>>;
}

const LicenseFilter = ({
  licenseFilter,
  setLicenseFilter,
}: ILicenseFilterProps): JSX.Element => {
  if (!!licenseFilter) {
    return (
      <div
        onClick={() => setLicenseFilter(null)}
        role="button"
        tabIndex={0}
        aria-label="Remove Gender Filter"
        className="py-3 px-4 transition-all flex items-center gap-2 cursor-pointer capitalize bg-gray-1000/30 backdrop-blur-xl border border-white/20 xl:hover:border-white/60 rounded-8"
      >
        <CancelIcon className="!text-18 !text-white/90" />
        <div className="text-14">{licenseFilter}</div>
      </div>
    );
  }

  return (
    <Dropdown
      value={licenseFilter}
      setValue={setLicenseFilter}
      options={[
        { value: License.ROYALTY_FREE, label: "Royalty Free" },
        { value: License.COPYRIGHTED, label: "Community" },
        { value: License.PARODY, label: "Parody" },
      ]}
      placeholder="Select License"
    />
  );
};

export default LicenseFilter;
